import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { X } from 'lucide-react';
import { SiteSplashConfig } from '../../config/siteExperience';
import './SplashCard.css';

interface Props { splash: SiteSplashConfig; partnerName?: string; onDismiss: () => void; preview?: boolean; }

export const SplashCard: React.FC<Props> = ({ splash, partnerName, onDismiss, preview = false }) => {
  const { t } = useTranslation('common');
  const clean = useMemo(() => DOMPurify.sanitize(splash.contentHtml, { ADD_ATTR: ['target'] }), [splash.contentHtml]);
  const classic = splash.presentation === 'classic-trusscore';
  return (
    <div className={`site-splash-card ${classic ? 'site-splash-card--classic' : 'site-splash-card--brand'} ${preview ? 'site-splash-card--preview' : ''}`} style={!classic ? { background: splash.backgroundColor || '#ffffff', color: foregroundFor(splash.backgroundColor || '#ffffff') } : undefined} onClick={e => e.stopPropagation()}>
      <button type="button" className="site-splash-close" onClick={onDismiss} aria-label={t('auth:close')}><X size={16} /></button>
      {splash.imageUrl && <img className="site-splash-image" src={splash.imageUrl} alt={splash.imageAlt || partnerName || t('splash.imageAlt')} onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }} />}
      {clean && <div className="site-splash-content" dangerouslySetInnerHTML={{ __html: clean }} />}
      {splash.ctaLabel && splash.ctaUrl && <a className="site-splash-cta" href={splash.ctaUrl} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>{splash.ctaLabel}</a>}
    </div>
  );
};
function foregroundFor(hex: string): string {
  const match = hex.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i); if (!match) return '#1a1a2e';
  let h=match[1]; if(h.length===3)h=h.split('').map(c=>c+c).join('');
  const r=parseInt(h.slice(0,2),16),g=parseInt(h.slice(2,4),16),b=parseInt(h.slice(4,6),16);
  return (0.2126*r+0.7152*g+0.0722*b)/255>.6?'#1a1a2e':'#ffffff';
}
export default SplashCard;
